import { Variable } from '@optimus-web/common';
import { BadgeVariant } from '@optimus-web/local-tokens';
import {
    BadgeContainerElement,
    BadgeElement,
    BadgeWrapperContainerElement,
    NOTIFICATION_BADGE_SIZE,
    SMALL_NOTIFICATION_BADGE_SIZE,
} from './style';

export interface BadgeWrapperProps extends Variable<BadgeVariant> {
    children?: React.ReactChild;
    active?: boolean;
    amount?: number | string;
}

export const Badge = ({ variant, active = true, amount, children, ...other }: BadgeWrapperProps) => {
    const badgeSize = amount !== undefined ? NOTIFICATION_BADGE_SIZE : SMALL_NOTIFICATION_BADGE_SIZE;

    if (children) {
        return (
            <BadgeWrapperContainerElement {...other}>
                {children}
                {active && (
                    <BadgeContainerElement $size={badgeSize}>
                        <BadgeElement variant={variant}>{amount}</BadgeElement>
                    </BadgeContainerElement>
                )}
            </BadgeWrapperContainerElement>
        );
    }

    return (
        <BadgeElement variant={variant} {...other}>
            {amount}
        </BadgeElement>
    );
};
